// task.model.ts
export interface Task {
  id?: number;
  taskName: string;
  dueDate: string;
  priority: Priority;
  status: Status;
  createdAt?: string;
  updatedAt?: string;
}

export enum Priority {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH'
}

export enum Status {
  NOT_STARTED = 'NOT_STARTED',
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED'
}

export const PriorityLabels: { [key in Priority]: string } = {
  [Priority.LOW]: 'Low',
  [Priority.MEDIUM]: 'Medium',
  [Priority.HIGH]: 'High'
};

export const StatusLabels: { [key in Status]: string } = {
  [Status.NOT_STARTED]: 'Not Started',
  [Status.PENDING]: 'Pending',
  [Status.IN_PROGRESS]: 'In Progress',
  [Status.COMPLETED]: 'Completed'
};